import { render, staticRenderFns } from "./SectionUnderDevelopment.vue?vue&type=template&id=5be8f6b6&"
import script from "./SectionUnderDevelopment.vue?vue&type=script&lang=js&"
export * from "./SectionUnderDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports